module.exports = __webpack_public_path__ + "static/media/like__non-active.e13988c0.svg";